import { BASE_URL } from "constants/routes";

const buildQueryString = ({ start, limit, sortBy, sortOrder }) => {
  let queryString = `start=${start}`;
  if (limit) {
    queryString += `&limit=${limit}`;
  }
  if (sortBy) {
    queryString += `&sortBy=${sortBy}`;
  }
  if (sortOrder) {
    queryString += `&sortOrder=${sortOrder}`;
  }
  return queryString;
};

export const GET_COMMENTS_BY_USER_ID = (
  userId,
  start,
  limit,
  sortBy,
  sortOrder
) =>
  `${BASE_URL}/comments/getCommentByUserId/${userId}?${buildQueryString({
    start,
    limit,
    sortBy,
    sortOrder,
  })}`;

export const GET_COMMENTS_BY_WORKFLOW_ID = (
  workFlow_id,
  start,
  limit,
  sortBy,
  sortOrder
) =>
  `${BASE_URL}/comments/getComment/${workFlow_id}?${buildQueryString({
    start,
    limit,
    sortBy,
    sortOrder,
  })}`;

export const GET_COMMENT_BY_ID = (commentId) =>
  `${BASE_URL}/comments/getCommentById/${commentId}`;

export const ADD_COMMENT = `${BASE_URL}/comments/createComment`;

export const GET_LAST_COMMENT = (workFlow_id) =>
  `${BASE_URL}/comments/getLastComment/${workFlow_id}`;

export const EDIT_COMMENT = (commentId) =>
  `${BASE_URL}/comments/editCommentById/${commentId}`;

export const GET_ACTIVITY_LIST_BY_WORKFLOW_ID = (
  workFlow_id,
  start,
  limit,
  sortBy,
  sortOrder
) =>
  `${BASE_URL}/activity-list/getActivityByWorkflowId/${workFlow_id}?${buildQueryString(
    { start, limit, sortBy, sortOrder }
  )}`;

export const GET_USERLIST_BY_SEARCH_QUERY = (searchQuery) =>
  `${BASE_URL}/users/getAllUsersList/?search=${searchQuery}`;

export const GET_USERMAILS_BY_ROLEID = `${BASE_URL}/users/fetchUsersWithRole`

export const GET_ROLES_INFO = `${BASE_URL}/users/getRolesInfo`;

export const POST_REQUESTED_DOCS = (
  primaryWorkflowId,
  userId,
  subWfId,
  organisation_id
) =>
  `${BASE_URL}/workflow/createRequestedDocument/${primaryWorkflowId}/${userId}/${subWfId}/${organisation_id}`;

export const GET_REQUESTED_DOC_BY_REQ_ID = (
  primaryWorkflowId,
  userId,
  subWfId,
  requestedId
) =>
  `${BASE_URL}/workflow/getRequestedDocument/${primaryWorkflowId}/${userId}/${subWfId}/${requestedId}`;

export const GET_SUPPORTING_DOCUMENTS_CONFIG_VY_REQUESTED_ID = (requestedId) =>
  `${BASE_URL}/workflow-cluster/getClusterDynamicForms/${requestedId}`;

export const UPLOAD_SUPPORTING_DOCS_REQUESTED_TO_WORKFLOW = (
  organizationId,
  subWfId,
  requestedId
) =>
  `${BASE_URL}/workflow/uploadSupportingDocuments/${organizationId}/${subWfId}/${requestedId}`;

export const CREATE_SUPPORTING_DOCUMENTS_CONFIG_TO_WORKFLOW = `${BASE_URL}/workflow-cluster/createClusterDynamicForms`;

export const GET_DASHBOARD_DETAIL_CONFIG_BY_ORGANISATION_ID_AND_CONFIG_TYPE = `${BASE_URL}/dashboard-configuration/getDashboardDetail`;

export const GET_VKYC_STATUS_ON_PRIMARY_WORKFLOW_ID = (primaryWorkflowId) =>
  `${BASE_URL}/workflow/getVCIPResponseByPrimaryWorkFlowId/${primaryWorkflowId}`;

export const SEND_VKYC_REMINDER_TO_USER = `${BASE_URL}/workflow/sendReminderToUserForVKYC`;


export const CREATE_PAYMENT_REQUEST = `${BASE_URL}/payment/createPaymentDocumentForWorkFlow`;
export const GET_PAYMENT_AND_USER_INFO = `${BASE_URL}/payment/getPaymentAndUserInfo`;
